const Cookie = {
    create: (name, value, days) => {
        let expires;
        if (days) {
            const date = new Date();
            // eslint-disable-next-line no-magic-numbers
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toGMTString()}`;
        } else {
            expires = '';
        }
        document.cookie = `${name}=${value}${expires}; path=/`;
    },
    read: name => {
        const ref = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let cb = ca[i];
            while (cb.charAt(0) === ' ') {
                cb = cb.substring(1, cb.length);
            }
            if (cb.indexOf(ref) === 0) {
                return cb.substring(ref.length, cb.length);
            }
        }
        return null;
    },
    delete: name => {
        // eslint-disable-next-line no-magic-numbers
        Cookie.create(name, '', -1);
    }
};

export default Cookie;
